export const CODINGADVICES_BEGIN_WAIT = "CODINGADVICES_BEGIN_WAIT";
export const CODINGADVICES_END_WAIT = "CODINGADVICES_END_WAIT";

export const CODINGADVICES_UPDATE_CODINGADVICES = "CODINGADVICES_UPDATE_CODINGADVICES";
export const CODINGADVICES_UPDATE_CODES = "CODINGADVICES_UPDATE_CODES";
